import React from "react";
import LoadingStyle2 from "../../../Loading/LoadingStyle2";

export default (props: any) => {
  
  return(<div className={"window-candidate-v2__loading"}>
    <LoadingStyle2 />
  </div>)
}